export function togglePackageDropdown(packageIndex) {
  const dropdown = document.querySelector(`[data-package-index="${packageIndex}"]`);
  if (!dropdown) return;
  const header = dropdown.querySelector(".order-details-shipment-group-header");
  const content = dropdown.querySelector(".order-details-shipment-group-content");
  const arrow = dropdown.querySelector(".order-details-shipment-group-arrow");
  if (!header || !content || !arrow) return;
  const isExpanded = content.classList.contains("expanded");
  if (isExpanded) {
    header.classList.add("collapsed");
    content.classList.remove("expanded");
    content.style.display = "none";
    arrow.classList.remove("expanded");
  } else {
    header.classList.remove("collapsed");
    content.classList.add("expanded");
    content.style.display = "block";
    arrow.classList.add("expanded");
  }
}
export function registerPackageDropdownToggle() {
  if (typeof window !== "undefined") {
    window.togglePackageDropdown = togglePackageDropdown;
  }
}
